const LubeServSite = {
  LubeServAnabuImusCavite: "lubeserv-anabu-imus-cavite",
  LubeServTelabastaganPampanga: "lubeserv-telabastagan-pampanga",
  LubeServCarmonaCavite: "lubeserv-carmona-cavite",
  LubeServCamarinCaloocan: "lubeserv-camarin-caloocan",
  LubeServShawBlvd: "lubeserv-shaw-blvd",
};

export default LubeServSite;
